const Span = ({ children, className, ...others }) => {
  return (
    <span
      className={`text-xs leading-14lh text-light_secondary_label dark:text-light_bg_grey ${className}`}
      {...others}
    >
      {children}
    </span>
  );
};

export default Span;
